<template>
  <div class="setting_modal">
    <div class="setting_customize">
      <div class="setting_customize_header">
        <p class="setting_customize_header_title" v-if="optionCustomizeColor === 2">
          {{ labelProperties.HEAD_MODAL }}
        </p>
        <p class="setting_customize_header_title" v-if="optionCustomizeColor === 1">
          {{ labelProperties.HEAD_EDIT_DELETE_THEME }}
        </p>
        <div class="setting_customize_header_close" @click="cancel">
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#AAA" fill-rule="evenodd">
              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"/>
              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"/>
            </g>
          </svg>
        </div>
      </div>
      <div class="setting_customize_body">
        <div class="setting_customize_menu">
          <div class="setting_customize_menu_heading">
            <p class="setting_customize_menu_title">
              {{ labelProperties.MENU_THEME_NAME_TITLE }}
            </p>
            <p class="setting_label">
              {{ labelProperties.LABEL_REQUIRE }}
            </p>
          </div>
          <div class="setting_customize_menu_item">
            <input class="setting_form_text" type="text" :placeholder="labelProperties.PLACE_HOLDER"
                   v-model="draftColors.themeName" ref="themeName">
            <p v-if="isEmptyThemeName" class="empty-theme-name">
              {{ messageProperties.MESSAGE_EMPTY_THEME_NAME }}
            </p>
            <p v-if="isOverThemeNameLength" class="empty-theme-name">
              {{ maxlengthProperties.MAX_LENGTH_THEME_NAME }}
              {{ messageProperties.MESSAGE_OVER_LENGTH_THEME_NAME }}
            </p>
          </div>
          <div class="setting_customize_menu_heading">
            <p class="setting_customize_menu_title">
              {{ labelProperties.MENU_COLOR_TITLE }}
            </p>
          </div>
          <div class="setting_customize_menu_item" v-for="(colorSetting, index) in colorSettings" :key="index">
            <p class="setting_customize_menu_label">
              {{ colorSetting.name }}
            </p>
            <div class="setting_form_color">
              <input class="setting_form_color_picker" type="color" v-model="colorSetting.color"
                     @input="handleChangeColor(colorSetting.name, colorSetting.color)"/>
              <input class="setting_form_color_name" type="text" v-model="colorSetting.color"
                     @input="handleChangeColor(colorSetting.name, colorSetting.color)">
            </div>
          </div>
        </div>
        <div class="setting_customize_preview" v-bind:style="{ backgroundColor: draftColors.pageBackground }">
          <div class="jobs_wrapper">
            <h1 class="jobs_page_title_preview setting_word_break" v-bind:style="{ color: draftColors.pageText }" v-if="entryPageName">
              {{ entryPageName }}
            </h1>
            <h1 class="jobs_page_title" v-bind:style="{ color: draftColors.pageText }" v-else>
              {{ labelProperties.ENTRY_PAGE_TITLE }}
            </h1>
            <p class="jobs_table_annotation_preview setting_word_break" v-if="entryOverview">{{ entryOverview }}</p>
            <div class="entry_stepbar">
              <ul class="entry_stepbar_list" v-bind:style="{border: '1px solid'+ draftColors.borderColor}">
                <li class="entry_stepbar_item"
                    v-bind:style="[ step >= 1 ? {backgroundColor:draftColors.keyColor, '--keyColor': draftColors.keyColor } : {}, ]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleEntry && message.titleEntry.length <= messageSettingsProperties.TITLE.ENTRY_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 1 ? {color: draftColors.highlightText} : {}]">
                    {{ message.titleEntry }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 1 ? {color: draftColors.highlightText} : {}]">
                    {{ labelProperties.ENTRY_STEP_TITLE }}
                  </span>
                </li>
                <li class="entry_stepbar_item"
                    v-bind:style="[step >= 2 ? {backgroundColor: draftColors.keyColor, '--keyColor': draftColors.keyColor} : {backgroundColor: draftColors.subColor, '--keyColor': draftColors.subColor}]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleConfirm && message.titleConfirm.length <= messageSettingsProperties.TITLE.CONFIRM_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 2 ? { color: draftColors.highlightText } : {color: draftColors.pageText}]">
                    {{ message.titleConfirm }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 2 ? { color: draftColors.highlightText } : {color: draftColors.pageText}]">
                    {{ labelProperties.CONFIRM_STEP_TITLE }}
                  </span>
                </li>
                <li class="entry_stepbar_item"
                    v-bind:style="[step >= 3 ? { backgroundColor: draftColors.keyColor , '--keyColor': draftColors.keyColor} : {backgroundColor: draftColors.subColor}]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleCompletion && message.titleCompletion.length <= messageSettingsProperties.TITLE.COMPLETE_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 3? { color: draftColors.highlightText }:{color: draftColors.pageText}]">
                    {{ message.titleCompletion }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 3 ? { color: draftColors.highlightText } : {color: draftColors.pageText}]">
                    {{ labelProperties.COMPLETE_STEP_TITLE }}
                  </span>
                </li>
              </ul>
            </div>
            <div v-show="step === 1" v-bind:style="{backgroundColor: draftColors.pageBackground}">
              <div class="entry_error" v-show="messages && messages.length > 0">
                <p class="entry_error_title">
                  {{ messageProperties.ENTRY_ERROR_TITLE }}
                </p>
                <ul class="entry_error_list">
                  <li class="entry_error_item" v-for="(message, index) in messages" :key="index">
                    <a class="entry_error_link">
                      {{ message }}
                    </a>
                  </li>
                </ul>
              </div>
              <div v-if="draftCategories.length > 0">
                <div v-for="(category, index) in draftCategories" :key="index">
                  <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
                    <h2 class="jobs_category_title"
                        v-bind:style="{ color: draftColors.pageText, borderLeftColor:draftColors.keyColor }">
                      {{ category.categoryName }}
                      <span v-if="category.countCate">
                        {{ category.countCate }}
                      </span>
                    </h2>
                    <div class="jobs_table_wrapper">
                      <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                        <template v-if="!isEmptyItem(item)">
                          <tbody class="jobs_table_body">
                          <tr class="jobs_table_rows">
                            <th class="jobs_table_head"
                                v-bind:style="[{backgroundColor: draftColors.subColor}, indexItem === 0 ? {border: '1px solid'+ draftColors.borderColor}: {borderLeft: '1px solid'+ draftColors.borderColor, borderRight: '1px solid'+ draftColors.borderColor, borderBottom: '1px solid'+ draftColors.borderColor}]">
                              <div class="jobs_table_head_holder">
                              <span class="jobs_table_label" v-bind:style="{ color: draftColors.pageText }">
                                {{ item.itemName }}
                              </span>
                                <span class="entry_required_label" v-if="item.itemRequired"
                                      v-bind:style="{backgroundColor:draftColors.requiredLabel, color: draftColors.requiredLabelText}">
                                {{ labelProperties.LABEL_REQUIRE }}
                              </span>
                              </div>
                              <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                                <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                                <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                              </div>
                            </th>
                            <td class="jobs_table_cell"
                                v-bind:style="[indexItem === 0 ? {border: '1px solid'+ draftColors.borderColor} : {borderLeft: '1px solid'+ draftColors.borderColor, borderRight: '1px solid'+ draftColors.borderColor, borderBottom: '1px solid'+ draftColors.borderColor}]">
                              <div class="jobs_table_form_rows">
                                <div class="jobs_table_form_item">
                                  <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                                       :key="indexResourceField" class="row">
                                    <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)"
                                         :key="indexResource">
                                      <div v-if="resource.type !== 'blank'">
                                        <InputComponent
                                          class="mt-1"
                                          :resource="resource"
                                          :master="getMasterData(resource.master_name)"
                                          :year="year"
                                          :month="month"
                                          :day="day"
                                          :draftColors="draftColors"
                                          :numberOfItem="item.resourceField.length"
                                          @updateCheckErrorInput="updateCheckErrorInput"
                                          @updatePhoto="updatePhoto"
                                          @updateFiles="updateFiles"
                                          :itemName="item.itemName"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span class="jobs_table_annotation setting_word_break" v-if="item.viewAnnotation && item.annotationText"
                                        v-bind:style="{color: draftColors.pageText}">
                                  ※{{ item.annotationText }}
                                </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </table>
                    </div>
                    <div class="setting_unit_add" v-if="index === findLastCategoryIndex('careers')">
                      <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                        {{ labelProperties.DUPLICATE_CARRIER }}
                      </a>
                    </div>
                    <div class="setting_unit_add" v-if="index === findLastCategoryIndex('educations')">
                      <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                        {{ labelProperties.DUPLICATE_EDUCATION }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="privacy.isEnabledPolicy && privacy.content !== ''" class="mt-2">
                <h2 class="jobs_category_title"
                    v-bind:style="{ color: draftColors.pageText, borderLeftColor:draftColors.keyColor }">
                  {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
                </h2>
                <textarea class="jobs_form_textarea" readonly v-model="privacy.content"/>
                <div class="entry_policy_checkbox">
                  <label class="jobs_form_label">
                    <input type="checkbox" v-model="agreePrivacyPolicy">
                    <span class="entry_policy_checkbox_text" v-bind:style="{ color: draftColors.pageText }">
                      {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
                    </span>
                  </label>
                </div>
              </div>
              <div class="entry_policy_checkbox" v-if="privacy.isEnabledUrl && privacy.textLink !== ''">
                <label class="jobs_form_label">
                  <input v-model="agreePrivacyPolicyLink" type="checkbox"/>
                  <a :href="privacy.url" class="ml-1 mr-3" v-bind:style="{color: draftColors.linkText}" target="_blank">
                    {{ privacy.textLink }}
                  </a>
                </label>
              </div>
              <div class="jobs_btn_box">
                <button class="jobs_btn_primary" @click="nextStep(2)"
                        :class="isAgreePrivacy() && countInputError === 0 ? '' : 'jobs_btn_disabled'"
                        v-bind:style="{color: draftColors.mainButtonText, backgroundColor:draftColors.mainButton,border: '1px solid'+ draftColors.borderColor }">
                  <span
                      v-if="!button.confirmButton || button.confirmButton.length > buttonSettingsProperties.CONFIRM_BUTTON_MAX_LENGTH">
                    {{ labelProperties.CONFIRM_BUTTON }}
                  </span>
                  <span v-else>
                    {{ button.confirmButton }}
                  </span>
                </button>
              </div>
            </div>
            <div v-show="step === 2" v-bind:style="{backgroundColor: draftColors.pageBackground}">
              <div class="entry_confirm">
                <pre class="entry_confirm_text customize_setting_entry_confirm" v-if="message && message.messageConfirm && message.messageConfirm.length <= messageSettingsProperties.MESSAGE.CONFIRM_BODY_MAX_LENGTH">{{message.messageConfirm}}</pre>
              </div>
              <div v-if="draftCategories.length > 0">
                <div v-for="(category, index) in draftCategories" :key="index">
                  <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
                    <h2 class="jobs_category_title"
                        v-bind:style="{ color: draftColors.pageText, borderLeftColor:draftColors.keyColor }">
                      {{ category.categoryName }}
                      <span v-if="category.countCate">
                        {{ category.countCate }}
                      </span>
                    </h2>
                    <div class="jobs_table_wrapper">
                      <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                        <template v-if="!isEmptyItem(item)">
                          <tbody class="jobs_table_body">
                          <tr class="jobs_table_rows">
                            <th class="jobs_table_head"
                                v-bind:style="[ {backgroundColor: draftColors.subColor}, indexItem === 0 ? {border: '1px solid'+ draftColors.borderColor}: {borderLeft: '1px solid'+ draftColors.borderColor, borderRight: '1px solid'+ draftColors.borderColor, borderBottom: '1px solid'+ draftColors.borderColor}]">
                              <div class="jobs_table_head_holder">
                              <span class="jobs_table_label" v-bind:style="{color: draftColors.pageText }">
                                {{ item.itemName }}
                              </span>
                                <span class="entry_required_label" v-if="item.itemRequired"
                                      v-bind:style="{backgroundColor: draftColors.requiredLabel, color: draftColors.requiredLabelText}">
                                {{ labelProperties.LABEL_REQUIRE }}
                              </span>
                              </div>
                              <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                                <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                                <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                              </div>
                            </th>
                            <td class="jobs_table_cell"
                                v-bind:style="[ indexItem === 0 ? {border: '1px solid'+ draftColors.borderColor} : {borderLeft: '1px solid'+ draftColors.borderColor, borderRight: '1px solid'+ draftColors.borderColor, borderBottom: '1px solid'+ draftColors.borderColor}]">
                              <div class="jobs_table_form_rows">
                                <div class="jobs_table_form_item">
                                  <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                                       :key="indexResourceField" class="row">
                                    <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)"
                                         :key="indexResource">
                                      <div v-if="resource.type !== 'blank'">
                                        <InputComponent
                                          class="mt-1"
                                          :resource="resource"
                                          :indexResource="indexResourceField"
                                          :master="getMasterData(resource.master_name)"
                                          :year="year"
                                          :month="month"
                                          :day="day"
                                          :draftColors="draftColors"
                                          :isDisableEditing="isDisableEditing"
                                          :numberOfItem="item.resourceField.length"
                                          :photo="photo"
                                          :attachemnts="files"
                                          ref="InputComponentRef"
                                          :itemName="item.itemName"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span class="jobs_table_annotation setting_word_break" v-if="item.viewAnnotation && item.annotationText"
                                        v-bind:style="{color: draftColors.pageText}">
                                  ※{{ item.annotationText }}
                                </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="privacy.isEnabledPolicy && privacy.content !== ''" class="mt-2">
                <h2 class="jobs_category_title"
                    v-bind:style="{ color: draftColors.pageText, borderLeftColor:draftColors.keyColor }">
                  {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
                </h2>
                <textarea class="jobs_form_textarea" readonly v-model="privacy.content"/>
                <div class="entry_policy_checkbox">
                  <label class="jobs_form_label">
                    <input type="checkbox" v-model="agreePrivacyPolicy" disabled />
                    <span class="entry_policy_checkbox_text" v-bind:style="{ color: draftColors.pageText }">
                      {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
                    </span>
                  </label>
                </div>
              </div>
              <div class="entry_policy_checkbox" v-if="privacy.isEnabledUrl && privacy.textLink !== ''">
                <label class="jobs_form_label">
                  <input v-model="agreePrivacyPolicyLink" type="checkbox" disabled />
                  <a :href="privacy.url" class="ml-1 mr-3" v-bind:style="{color: draftColors.linkText}" target="_blank">
                    {{ privacy.textLink }}
                  </a>
                </label>
              </div>
              <div class="jobs_btn_box">
                <button class="jobs_btn_secondary" @click="backStep(1)"
                        v-bind:style="{color: draftColors.subButtonText, backgroundColor: draftColors.subButton, border: '1px solid'+ draftColors.borderColor }">
                  <span
                      v-if="!button.returnButton || button.returnButton.length > buttonSettingsProperties.RETURN_BUTTON_MAX_LENGTH">
                    {{ labelProperties.BACK_BUTTON }}
                  </span>
                  <span v-else>
                    {{ button.returnButton }}
                  </span>
                </button>
                <button class="jobs_btn_primary" @click="step = 3"
                        v-bind:style="{ color: draftColors.mainButtonText, backgroundColor: draftColors.mainButton, border: '1px solid' + draftColors.borderColor }">
                <span
                    v-if="!button.entryButton || button.entryButton.length > buttonSettingsProperties.ENTRY_BUTTON_MAX_LENGTH">
                  {{ labelProperties.ENTRY_BUTTON }}
                </span>
                  <span v-else>
                  {{ button.entryButton }}
                </span>
                </button>
              </div>
            </div>
            <div v-show="step === 3" v-bind:style="{backgroundColor: draftColors.pageBackground}">
              <div class="entry_complete">
                <p class="entry_complete_title">
                  <span
                      v-if="message && message.messageTitleCompletion && message.messageTitleCompletion.length <= messageSettingsProperties.MESSAGE.COMPLETE_TITLE_MAX_LENGTH">
                    {{ message.messageTitleCompletion }}
                  </span>
                  <span v-else>
                    {{ labelProperties.MESSAGE_TITLE_COMPLETION_DEFAULT }}
                  </span>
                </p>
                <pre class="entry_complete_text customize_setting_entry_confirm mt-3" v-if="message && message.messageBodyCompletion && message.messageBodyCompletion.length <= messageSettingsProperties.MESSAGE.COMPLETE_BODY_MAX_LENGTH">{{message.messageBodyCompletion}}</pre>
                <p class="entry_complete_text mt-5" v-else>
                  {{ labelProperties.MESSAGE_CONTENT_1 }}
                  <br>
                  {{ labelProperties.MESSAGE_CONTENT_2 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setting_customize_footer">
        <div class="setting_customize_footer_delete">
          <button @click="openConfirmRemoveTheme" class="setting_customize_footer_delete_button"
                  :class="isShowRemoveTheme ? 'is_disabled' : ''">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024" fill="#f16a6a">
              <path
                  d="M876.8 140.8s6.4 3.2-86.4-22.4c-83.2-25.6-160-32-160-32L624 48c-3.2-28.8-25.6-48-51.2-48H451.2c-25.6 0-48 19.2-51.2 44.8l-6.4 38.4s-80 6.4-160 32c-92.8 28.8-86.4 25.6-86.4 25.6-22.4 3.2-35.2 25.6-35.2 48v32h800v-32c0-22.4-12.8-44.8-35.2-48zM176 928c3.2 54.4 48 96 102.4 96h464c54.4 0 99.2-41.6 102.4-96L896 272H124.8L176 928zm508.8-508.8c0-16 16-28.8 32-28.8s28.8 16 28.8 32l-28.8 480c0 16-16 28.8-32 28.8s-28.8-16-28.8-32l28.8-480zM480 422.4c0-16 12.8-32 32-32 16 0 32 12.8 32 32v480c0 16-12.8 32-32 32-16 0-32-12.8-32-32v-480zm-172.8-32c16 0 32 12.8 32 28.8l28.8 480c0 16-12.8 32-28.8 32s-32-12.8-32-28.8l-28.8-480c0-16 12.8-28.8 28.8-32z"/>
            </svg>
            {{ labelProperties.BUTTON_DELETE_THEME }}
          </button>
          <div class="setting_modal" v-if="isOpenConfirmModal">
            <div class="setting_modal_box_customer">
              <div class="setting_modal_box_body_cusomer">
                <p class="setting_modal_box_text">
                  {{ labelProperties.MESSAGE_CONFIRM_DELETE_THEME }}
                </p>
              </div>
              <div class="setting_modal_box_actions_customer">
                <button class="setting_btn_outline mr-2" @click="closeModalConfirmDelete">
                  {{ labelProperties.BUTTON_CANCEL_DELETE_THEME }}
                </button>
                <button class="setting_btn_primary" @click="acceptRemoveTheme()">
                  {{ labelProperties.BUTTON_OK_DELETE_THEME }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_customize_footer_button">
          <button class="setting_btn_outline setting_btn_small" @click="cancel">
            {{ labelProperties.BUTTON_CLOSE_MODAL }}
          </button>
          <button class="setting_btn_primary setting_btn_small" @click="saveAsDraft">
            {{ labelProperties.BUTTON_REFLECT }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InputComponent from "../../GeneralComponents/InputComponent.vue";
import VueToast from "vue-toast-notification";
import labelProperties
  from "../../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import messageProperties
  from "../../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-message.json";
import maxlengthProperties
  from "../../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-maxlength.json";
import generalService from "../../../../services/GeneralService";
import buttonSettingsProperties from "../../../../properties/entry_screen/button_tab/button-maxlength-settings.json";
import messageSettingsProperties from "../../../../properties/entry_screen/message_tab/message-maxlength-settings.json";

Vue.use(VueToast);

export default {
  name: "CustomizeScreenModal",
  props: [
    "categories",
    "colors",
    "message",
    "privacy",
    "masters",
    "button",
    "entryPageName",
    "entryOverview",
    "draftColors",
    "isShowRemoveTheme",
    "userId",
    "groupName",
    "optionCustomizeColor"
  ],
  components: {
    InputComponent,
  },
  data: function () {
    return {
      messages: [],
      master: [],
      step: 1,
      resource: {},
      value: {},
      agreePrivacyPolicy: false,
      agreePrivacyPolicyLink: false,
      confirmInput: {},
      applicationCompleted: {},
      screen: {},
      color: "#714141",
      colorSettings: [
        {
          id: 1,
          name: labelProperties.BACKGROUND_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 2,
          name: labelProperties.KEY_COLOR,
          color: "#333333",
        },
        {
          id: 3,
          name: labelProperties.SUB_COLOR,
          color: "#F7F7F7",
        },
        {
          id: 4,
          name: labelProperties.BORDER_COLOR,
          color: "#DDDDDD",
        },
        {
          id: 5,
          name: labelProperties.TEXT_COLOR,
          color: "#333333",
        },
        {
          id: 6,
          name: labelProperties.LINK_TEXT_COLOR,
          color: "#337AB7",
        },
        {
          id: 7,
          name: labelProperties.HIGHLIGHT_TEXT_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 8,
          name: labelProperties.MAIN_BUTTON_COLOR,
          color: "#DA9716",
        },
        {
          id: 9,
          name: labelProperties.MAIN_BUTTON_TEXT_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 10,
          name: labelProperties.SUB_BUTTON_COLOR,
          color: "#FFFFFF",
        },
        {
          id: 11,
          name: labelProperties.SUB_BUTTON_TEXT_COLOR,
          color: "#333333",
        },
        {
          id: 12,
          name: labelProperties.REQUIRED_LABEL_COLOR,
          color: "#FF2E3D",
        },
        {
          id: 13,
          name: labelProperties.REQUIRED_LABEL_TEXT_COLOR,
          color: "#FFFFFF",
        },
      ],
      isDisableEditing: false,
      year: "",
      month: "",
      day: "",
      isOpenConfirmModal: false,
      isEmptyThemeName: false,
      isOverThemeNameLength: false,
      draftCategories: [],
      labelProperties: labelProperties,
      messageProperties: messageProperties,
      maxlengthProperties: maxlengthProperties,
      buttonSettingsProperties: buttonSettingsProperties,
      messageSettingsProperties: messageSettingsProperties,
      log: {
        info: {},
      },
      numberOfItem:0,
      countInputError: 0,
      itemChecks: [],
      photo: "",
      files: [
        {
          content: "",
        },
        {
          content: "",
        },
        {
          content: "",
        },
      ],
    };
  },
  watch: {
    categories(newVal) {
      this.draftCategories = JSON.parse(JSON.stringify(newVal));
    },
  },
  updated() {
    this.handleBindDate();
    this.updateColorSettings();
  },
  methods: {
    isAgreePrivacy(){
      if(this.privacy.isEnabledUrl && this.privacy.isEnabledPolicy){
        return this.agreePrivacyPolicyLink && this.agreePrivacyPolicy;
      }else if(this.privacy.isEnabledUrl || this.privacy.isEnabledPolicy){
        return this.agreePrivacyPolicyLink || this.agreePrivacyPolicy;
      }else{
        return true;
      }
    },

    updatePhoto(file) {
      this.photo = file;
    },

    updateFiles(file, type) {
      switch (type) {
        case 0:
          this.files[0].content = file;
          break;
        case 1:
          this.files[1].content = file;
          break;
        case 2:
          this.files[2].content = file;
          break;
      }
    },

    isEmptyCategory(index) {
      if (this.categories[index].item.length === 0) {
        return true;
      }

      return this.categories[index].item.filter(item => !this.isEmptyItem(item)).length === 0;
    },

    isEmptyItem(item) {
      if(item.itemDeleted) {
        return true;
      }

      if (item.resourceField.length === 1) {
        return item.resourceField[0].isDeletedByMainSystem;
      }

      if (item.resourceField.length > 1) {
        let numberItemDeleted = item.resourceField.filter(resourceSetting => resourceSetting && resourceSetting.isDeletedByMainSystem).length;
        return numberItemDeleted >= item.resourceField.length;
      }

      return true;
    },

    updateCheckErrorInput(resource) {
      this.countInputError = 0;
      let checkIncludeItem = this.itemChecks.some(item => item && (item.name === resource.name || item.display_name === resource.display_name));
      if (!checkIncludeItem) {
        this.itemChecks.push(resource);
      }

      if (this.itemChecks.length <= 0) {
        return;
      }

      this.countInputError = this.itemChecks.filter(itemCheck => itemCheck && (itemCheck.isWrongValue || itemCheck.isWrongFormat)).length;
    },

    updateColorSettings() {
      this.colorSettings[0].color = this.draftColors.pageBackground;
      this.colorSettings[1].color = this.draftColors.keyColor;
      this.colorSettings[2].color = this.draftColors.subColor;
      this.colorSettings[3].color = this.draftColors.borderColor;
      this.colorSettings[4].color = this.draftColors.pageText;
      this.colorSettings[5].color = this.draftColors.linkText;
      this.colorSettings[6].color = this.draftColors.highlightText;
      this.colorSettings[7].color = this.draftColors.mainButton;
      this.colorSettings[8].color = this.draftColors.mainButtonText;
      this.colorSettings[9].color = this.draftColors.subButton;
      this.colorSettings[10].color = this.draftColors.subButtonText;
      this.colorSettings[11].color = this.draftColors.requiredLabel;
      this.colorSettings[12].color = this.draftColors.requiredLabelText;
    },

    backStep(step) {
      this.handleBindDate();
      this.step = step;
    },

    nextStep(nextStep) {
      this.messages = [];
      if (this.validator()) {
        if(nextStep === 2){
          this.updateFileRefInputComponent();
        }
        this.handleBindDate();
        this.isDisableEditing = true;
        this.step = nextStep;
      } else {
        return this.messages;
      }
    },

    updateFileRefInputComponent(){
      if(this.$refs.InputComponentRef.length === 0){
        return;
      }
      let indexOfRefPhoto = this.$refs.InputComponentRef.findIndex(ref => ref && ref.resource && ref.resource.name === "photo");
      let indexOfRefAttachemnts = this.$refs.InputComponentRef.findIndex(ref => ref && ref.resource && ref.resource.name === "files");
      if(indexOfRefPhoto > 0){
        this.$refs.InputComponentRef[indexOfRefPhoto].updatePhoto();
      }
      if(indexOfRefAttachemnts > 0){
        this.$refs.InputComponentRef[indexOfRefAttachemnts].updateAttachments();
      }
    },

    handleBindDate() {
      this.draftCategories
          .filter((category) => category.item && category.item.length > 0)
          .forEach((category) => {
            category.item
                .filter(
                    (item) => item.resourceField && item.resourceField.length > 0
                )
                .forEach((item) => {
                  item.resourceField
                      .filter(
                          (resource) =>
                              resource.type === "date" &&
                              resource.name === "birth_date" &&
                              resource.default_value
                      )
                      .forEach((resource) => {
                        const date = new Date(resource.default_value);
                        this.year = date.getYear() + 1900;
                        this.month = date.getMonth() + 1;
                        this.day = date.getDate();
                      });
                });
          });
    },

    validator() {
      this.draftCategories
          .filter((category) => category.item && category.item.length > 0 && !category.categoryDeleted)
          .forEach((category) => {category.item
            .filter((item) => item.itemRequired && !item.itemDeleted)
            .forEach((item) => {item.resourceField
                .filter((resource) => resource.type !== "blank" && (!resource.itemResourceDeleted || !resource.isDeletedByMainSystem))
                .forEach((resource) => {
                let isEmptyValue = false;
                if(resource.name !== 'files' && resource.name !== 'photo'){
                  isEmptyValue = !resource.default_value || resource.default_value === "" || resource.default_value.length === 0;
                }
                let isEmptyPhoto = resource.name === 'photo' && !this.photo;
                let isEmptyFiles = resource.name === 'files' && this.files.filter(file => file && file.content).length === 0;

                if (isEmptyValue || isEmptyPhoto || isEmptyFiles) {
                  if (this.messages.includes(item.itemName)) {
                    return;
                  }

                  this.messages.push(item.itemName);
                }
              });
            });
          });
      return this.messages.length <= 0;
    },

    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master === master_name) {
          return [...this.masters[master].items];
        }
      }
    },

    buildListItem(resourceField) {
      let result = [];
      resourceField.forEach((field) => {
        if (!result || !result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder] = [field];
        } else if (result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder].push(field);
        }
      });

      return result;
    },

    handleChangeColor(position, colorCode) {
      switch (position) {
        case labelProperties.BACKGROUND_COLOR:
          this.draftColors.pageBackground = colorCode.toUpperCase();
          this.colorSettings[0].color = colorCode.toUpperCase();
          break;
        case labelProperties.KEY_COLOR:
          this.draftColors.keyColor = colorCode.toUpperCase();
          this.colorSettings[1].color = colorCode.toUpperCase();
          break;
        case labelProperties.SUB_COLOR:
          this.draftColors.subColor = colorCode.toUpperCase();
          this.colorSettings[2].color = colorCode.toUpperCase();
          break;
        case labelProperties.BORDER_COLOR:
          this.draftColors.borderColor = colorCode.toUpperCase();
          this.colorSettings[3].color = colorCode.toUpperCase();
          break;
        case labelProperties.TEXT_COLOR:
          this.draftColors.pageText = colorCode.toUpperCase();
          this.colorSettings[4].color = colorCode.toUpperCase();
          break;
        case labelProperties.LINK_TEXT_COLOR:
          this.draftColors.linkText = colorCode.toUpperCase();
          this.colorSettings[5].color = colorCode.toUpperCase();
          break;
        case labelProperties.HIGHLIGHT_TEXT_COLOR:
          this.draftColors.highlightText = colorCode.toUpperCase();
          this.colorSettings[6].color = colorCode.toUpperCase();
          break;
        case labelProperties.MAIN_BUTTON_COLOR:
          this.draftColors.mainButton = colorCode.toUpperCase();
          this.colorSettings[7].color = colorCode.toUpperCase();
          break;
        case labelProperties.MAIN_BUTTON_TEXT_COLOR:
          this.draftColors.mainButtonText = colorCode.toUpperCase();
          this.colorSettings[8].color = colorCode.toUpperCase();
          break;
        case labelProperties.SUB_BUTTON_COLOR:
          this.draftColors.subButton = colorCode.toUpperCase();
          this.colorSettings[9].color = colorCode.toUpperCase();
          break;
        case labelProperties.SUB_BUTTON_TEXT_COLOR:
          this.draftColors.subButtonText = colorCode.toUpperCase();
          this.colorSettings[10].color = colorCode.toUpperCase();
          break;
        case labelProperties.REQUIRED_LABEL_COLOR:
          this.draftColors.requiredLabel = colorCode.toUpperCase();
          this.colorSettings[11].color = colorCode.toUpperCase();
          break;
        case labelProperties.REQUIRED_LABEL_TEXT_COLOR:
          this.draftColors.requiredLabelText = colorCode.toUpperCase();
          this.colorSettings[12].color = colorCode.toUpperCase();
          break;
      }
    },

    saveAsDraft() {
      this.isEmptyThemeName = false;
      this.isOverThemeNameLength = false;
      if (this.draftColors && !this.draftColors.themeName) {
        this.isEmptyThemeName = true;
        this.$refs.themeName.focus();
        return;
      }

      if (
          this.draftColors.themeName &&
          this.draftColors.themeName.length > 45
      ) {
        this.isOverThemeNameLength = true;
        this.$refs.themeName.focus();
        return;
      }

      this.messages = [];
      this.$eventBus.$emit("unSaved", true);
      this.$emit("updateCustomizeSettings", this.draftColors);
    },
    async closeModalConfirmDelete() {
      await this.$emit(
          "setLoggerData",
          "Menu エントリー画面設定-Tab カラーテーマ-Popup customize color-Popup delete theme-Click button キャンセル"
      );
      this.isOpenConfirmModal = false;
    },

    async cancel() {
      this.step = 1;
      this.isEmptyThemeName = false;
      this.messages = [];
      this.$emit("close", this.colors);
    },

    async openConfirmRemoveTheme() {
      await this.$emit(
          "setLoggerData",
          "Menu エントリー画面設定-Tab カラーテーマ-Popup customize color-Click button このテーマを削除する"
      );
      this.isOpenConfirmModal = true;
    },

    async acceptRemoveTheme() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action =
          "Menu エントリー画面設定-Tab カラーテーマ-Popup customize color-Popup delete theme-Click button OK";
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.setLogger(this.log);

      this.isOpenConfirmModal = false;
      await this.$emit("remove", this.log.hash);
    },
    async setLogger(loggerData) {
      this.logs = loggerData;
      await generalService
          .sendLogger(this.logs.hash, this.logs.info.path, this.logs)
          .then((response) => {
            if (response.status === 200) {
              return true;
            }
          })
          .catch((e) => {
            console.log(e);
          });
    },

    checkPropertyCategory(categoryIndex) {
      let propertyCategory = "";
      if (this.checkCategoryItemsLength(categoryIndex) !== 0) {
        for (
            let i = 0;
            i < this.draftCategories[categoryIndex].item.length;
            i++
        ) {
          if (this.draftCategories[categoryIndex].item[i].itemDeleted) {
            continue;
          }

          let firstResourceName = this.draftCategories[categoryIndex].item[
              i
              ].resourceField.find(
              (resource) =>
                  resource.itemDisplayOrder === 0 && resource.itemColumn === 0
          ).name;
          if (firstResourceName.includes("educations.")) {
            propertyCategory = "educations";
            break;
          }

          if (firstResourceName.includes("careers.")) {
            propertyCategory = "careers";
            break;
          }
        }
      }

      return propertyCategory;
    },

    checkCategoryItemsLength(index) {
      let length = 0;
      this.draftCategories[index].item.forEach((i) => {
        if (i.itemDeleted === undefined || i.itemDeleted === false) {
          length++;
        }
      });

      return length;
    },

    duplicateCategory(index) {
      if (!this.draftCategories[index].countCate) {
        this.draftCategories[index].countCate = 1;
      }

      let newCategory = JSON.parse(JSON.stringify(this.draftCategories[index]));
      newCategory.item.forEach(i => i.resourceField.forEach(resource => resource.default_value = ""));
      newCategory.countCate = this.draftCategories[index].countCate + 1;
      this.draftCategories.splice(index + 1, 0, newCategory);
    },

    findLastCategoryIndex(groupType) {
      let count = -1;
      this.draftCategories.forEach((_, i) => {
        if (this.checkPropertyCategory(i) === groupType) {
          count = i;
        }
      });

      return count;
    },
  },
};
</script>

<style scoped>
.setting_content_heading_btn_holder > * + * {
  margin-left: 0 !important;
}

.setting_customize_header_title {
  align-self: self-start !important;
  margin-top: 2px;
}

.setting_customize_menu_heading {
  margin-bottom: unset !important;
}

.jobs_table_annotation {
  margin-top: unset !important;
}

.entry_stepbar_item:not(:last-child)::after {
  border-left-color: var(--keyColor) !important;
}

.setting_modal_box_customer {
  top: 0 !important;
  background-color: #fff;
  padding: 24px;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 420px;
  border: 1px solid rgb(143, 141, 141);
}

.setting_modal_box_body_cusomer {
  padding: 10px 0;
}

.setting_modal_box_actions_customer {
  display: -webkit-box;
  -webkit-box-align: end;
  -webkit-box-pack: end;
}

.empty-theme-name {
  color: red;
}

.setting_customize_header_title {
  align-self: self-start !important;
}

.customize_setting_entry_confirm{
  word-break: break-all;
  white-space: pre-wrap;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.setting_word_break {
  word-break: break-all;
}
</style>
